export default {
    getPlant: state => (plantId) => state.plants.find((plant) => plant.id == plantId),
}
